exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-size[data-v-110c27cc]{height:120px!important;width:120px!important}.description-area[data-v-110c27cc]{height:180px;overflow:scroll;word-wrap:break-word;overflow-wrap:break-word}.banner-team[data-v-110c27cc]{max-height:120px}[data-v-110c27cc]::-webkit-scrollbar:vertical{display:block}.general-title[data-v-110c27cc]{font-size:1.3rem}[data-v-110c27cc]::-webkit-scrollbar{width:7px!important;height:13px!important}", ""]);

// exports
